<div class="row" *ngIf="carrier && (carrier | json) != '{}'">
    <div class="col">
        <div class="row p-1">
            <div class="col-sm-3 font-weight-bold text-end">Carrier</div>
            <div class="col">
                <rmis-status [rmisStatusColor]="carrier.rmisStatusColor" [rmisStatusTextColor]="carrier.rmisStatusTextColor" [rmisStatusAbbrev]="carrier.rmisStatusAbbrev" [rmisStatusTooltip]="carrier.nonCertifiedReasons"></rmis-status>
                <a target="_blank" [routerLink]="['/carrier-detail', carrier.carrierCode]">
                    {{carrier.carrierCode}}
                </a>
                <br />
                <a target="_blank" [routerLink]="['/carrier-detail', carrier.carrierCode]">
                    {{carrier.carrierName}}
                </a>
                <br />
                {{carrier.carrierCity}}, {{carrier.carrierState}}
            </div>
        </div>
        <div class="row p-1" *ngIf="carrier.rmisStatus != 'Attached'">
            <div class="col-sm-3 font-weight-bold text-end">RMIS</div>
            <div class="col">
                <button type="button" class="btn btn-primary" tabindex="-1" (click)="checkCarrierRMISQualification()">Check Prequalification</button>
                <br />
                Last Check: {{getLastPotentialDate()}}
            </div>
        </div>
        <div class="row p-1" *ngIf="carrier.mcNumber&&carrier.mcNumber.startsWith('MC')">
            <div class="col-sm-3 font-weight-bold text-end">MC</div>
            <div class="col">
                {{carrier.mcNumber}}
            </div>
        </div>
        <div class="row p-1" *ngIf="carrier.dotNumber!=null">
            <div class="col-sm-3 font-weight-bold text-end">DOT</div>
            <div class="col">
                {{carrier.dotNumber}}
            </div>
        </div>
        <div class="row p-1" *ngIf="carrier.mcNumber&&carrier.mcNumber.startsWith('MX')">
            <div class="col-sm-3 font-weight-bold text-end">MX</div>
            <div class="col">
                {{carrier.mcNumber}}
            </div>
        </div>
        <div class="row p-1" *ngIf="carrier.scacNumber!=null&&carrier.scacNumber!=''">
            <div class="col-sm-3 font-weight-bold text-end">SCAC</div>
            <div class="col">
                {{carrier.scacNumber}}
            </div>
        </div>
        <div class="row p-1">
            <div class="col-sm-3 font-weight-bold text-end">Procurements</div>
            <div class="col">
                {{carrier.procurements}}
            </div>
        </div>
        <div class="row p-1">
            <div class="col-sm-3 font-weight-bold text-end">Team</div>
            <div class="col">
                {{carrier.carrierTeam}}
            </div>
        </div>
        <div class="row p-1">
            <div class="col-sm-3 font-weight-bold text-end">Incidents</div>
            <div class="col">
                {{carrier.carrierIncidents}}
            </div>
        </div>
        <div class="row p-1" *ngIf="carrier.carrierIncidents > 0">
            <div class="col-sm-3 font-weight-bold text-end">Last Incident</div>
            <div class="col">
                <!--{{getLastCarrierIncidentDate()}}-->
                {{carrier.lastCarrierIncidentDate | date:'shortDate'}}
            </div>
        </div>
        <div class="row p-1">
            <div class="col-sm-3 font-weight-bold text-end">Last Offer</div>
            <div class="col">
                {{carrier.lastOfferRate | currency}}
            </div>
        </div>
        <div class="row p-1">
            <div class="col-sm-3 font-weight-bold text-end">Last Rate</div>
            <div class="col">
                {{carrier.extendedRate | currency}}
            </div>
        </div>
        <div class="row p-1">
            <div class="col-sm-3 font-weight-bold text-end">Last Date</div>
            <div class="col">
                {{carrier.lastRan | date:'shortDate'}}
            </div>
        </div>
        <div class="row p-1">
            <div class="col-sm-3 font-weight-bold text-end">Min Rate</div>
            <div class="col">
                {{carrier.minRate > 0 ? (carrier.minRate | currency) : ''}}<br />
                {{carrier.minRate > 0 ? (carrier.minRateDate | date:'shortDate') : ''}}
            </div>
        </div>
        <div class="row p-1" *ngIf="!isBulkTender">
            <div class="col-sm-3 font-weight-bold text-end">Preferred</div>
            <div class="col">
                {{carrier.preferred == true ? 'Yes' : 'No'}}<br />
                {{carrier.preferredSetBy}}
            </div>
        </div>
        <div class="row p-1" *ngIf="!isBulkTender">
            <div class="col-sm-3 font-weight-bold text-end">Rank/Src</div>
            <div class="col">
                <h3 class="badge bg-primary m-1">{{carrier.confidenceRanking}}</h3>
                <strong>{{carrier.source}}</strong>
            </div>
        </div>
    </div>
</div>
